import React from 'react';
import { Link } from 'react-router-dom';
import '../../Logo.css';
import transparentLogo from '../../assets/tendera_logo_transparent.png';
import accentLogo from '../../assets/tendera_logo_loading.png';

const Logo = ({ isCollapsed }) => {
    return (
        <Link to="/" className={`logo-container ${isCollapsed ? 'collapsed' : ''}`}>
            <img
                src={isCollapsed ? accentLogo : transparentLogo}
                alt="Tendera logo"
                className="logo-image"
            />
        </Link>
    );
};

export default Logo;
